// extracted by mini-css-extract-plugin
export default {"mainContainer":"About_mainContainer__jSB-A","pictureContainer":"About_pictureContainer__VhDPc","textContainer":"About_textContainer__GL1K7"};